<template>
    <div :id="listing.id" :class="listingClass">
        <div class="header">
            <span v-if="!isPremiumListing" class="title">
                <span class="icon" v-if="isPreferred"><fa-icon :icon="['fas', 'thumbs-up']" aria-hidden="true"></fa-icon></span>
                <span class="icon" v-if="isAvoided"><fa-icon :icon="['fas', 'thumbs-down']" aria-hidden="true"></fa-icon></span>
                <span class="name">{{ displayName }}</span>
            </span>
            <a v-if="isPremiumListing" :href="detailLink" :title="listing.name" class="title view-details" @click.prevent="viewDetails">
                <span class="icon" v-if="isPreferred"><fa-icon :icon="['fas', 'thumbs-up']" aria-hidden="true"></fa-icon></span>
                <span class="icon" v-if="isAvoided"><fa-icon :icon="['fas', 'thumbs-down']" aria-hidden="true"></fa-icon></span>
                <span class="icon type" :style="headerIconStyle"></span>
                <span class="name">{{ displayName }}</span>
            </a>

            <span v-if="listing.properties.rating.count > 0" class="rating-value">
                <a href="#" :title="ratingTitle" @click.prevent="rateService($event, 1)">
                    <span v-if="listing.properties.rating.value == 0.5"><fa-icon :icon="['far', 'star-half-stroke']" aria-hidden="true"></fa-icon></span>
                    <span v-if="listing.properties.rating.value >= 1"><fa-icon :icon="['fas', 'star']" aria-hidden="true"></fa-icon></span>
                    <span v-if="listing.properties.rating.value < 0.5"><fa-icon :icon="['far', 'star']" aria-hidden="true"></fa-icon></span>
                </a>
                <a href="#" :title="ratingTitle" @click.prevent="rateService($event, 2)">
                    <span v-if="listing.properties.rating.value == 1.5"><fa-icon :icon="['far', 'star-half-stroke']" aria-hidden="true"></fa-icon></span>
                    <span v-if="listing.properties.rating.value >= 2"><fa-icon :icon="['fas', 'star']" aria-hidden="true"></fa-icon></span>
                    <span v-if="listing.properties.rating.value < 1.5"><fa-icon :icon="['far', 'star']" aria-hidden="true"></fa-icon></span>
                </a>
                <a href="#" :title="ratingTitle" @click.prevent="rateService($event, 3)">
                    <span v-if="listing.properties.rating.value == 2.5"><fa-icon :icon="['far', 'star-half-stroke']" aria-hidden="true"></fa-icon></span>
                    <span v-if="listing.properties.rating.value >= 3"><fa-icon :icon="['fas', 'star']" aria-hidden="true"></fa-icon></span>
                    <span v-if="listing.properties.rating.value < 2.5"><fa-icon :icon="['far', 'star']" aria-hidden="true"></fa-icon></span>
                </a>
                <a href="#" :title="ratingTitle" @click.prevent="rateService($event, 4)">
                    <span v-if="listing.properties.rating.value == 3.5"><fa-icon :icon="['far', 'star-half-stroke']" aria-hidden="true"></fa-icon></span>
                    <span v-if="listing.properties.rating.value >= 4"><fa-icon :icon="['fas', 'star']" aria-hidden="true"></fa-icon></span>
                    <span v-if="listing.properties.rating.value < 3.5"><fa-icon :icon="['far', 'star']" aria-hidden="true"></fa-icon></span>
                </a>
                <a href="#" :title="ratingTitle" @click.prevent="rateService($event, 5)">
                    <span v-if="listing.properties.rating.value == 4.5"><fa-icon :icon="['far', 'star-half-stroke']" aria-hidden="true"></fa-icon></span>
                    <span v-if="listing.properties.rating.value >= 5"><fa-icon :icon="['fas', 'star']" aria-hidden="true"></fa-icon></span>
                    <span v-if="listing.properties.rating.value < 4.5"><fa-icon :icon="['far', 'star']" aria-hidden="true"></fa-icon></span>
                </a>
            </span>

            <div class="icon menu">
                <a class="header-item" href="#" @click.prevent="toggleMenu" v-click-outside="closeDropdown" aria-label="Open dropdown menu">
                    <fa-icon :icon="['fas', 'bars']"></fa-icon>
                </a>
                <div v-if="showMenu" class="listing-menu">
                    <ul>
                        <template v-if="(isPremiumListing || userInfo.isAdmin || userInfo.isFleet) && !isDetails">
                            <li><a :href="detailLink" @click.prevent="viewDetails"><strong>{{ displayName }}</strong></a></li>
                        </template>
                        <template v-else>
                            <li><span class="company-name"><strong>{{ displayName }}</strong></span></li>
                        </template>
                        <li v-if="!showNumbers"><a href="#" @click.prevent="loadNumbers">Show Phone Numbers</a></li>

                        <li class="spacer"></li>

                        <template v-if="userInfo.isAdmin">
                            <li><a :href="editLocationLink()" @click.prevent="editLocation">Edit Listing</a></li>
                            <li v-if="userInfo.isOwned"><a :href="customerEditLocationLink()" @click.prevent="customerEditLocation">Customer Edit Listing</a></li>

                            <li><a :href="editHoursLink()" @click.prevent="editHours">Edit Hours</a></li>
                            <li v-if="userInfo.isOwned"><a :href="customerEditHoursLink()" @click.prevent="customerEditHours">Customer Edit Hours</a></li>
                        </template>
                        <template v-if="!userInfo.isAdmin && userInfo.isOwned">
                            <li><a :href="customerEditLocationLink()" @click.prevent="customerEditLocation">Edit Listing</a></li>
                            <li><a :href="customerEditHoursLink()" @click.prevent="customerEditHours">Edit Hours</a></li>
                        </template>
                        <template v-if="!userInfo.isAdmin && !userInfo.isOwned">
                            <li><a href="#" @click.prevent="reportLocation">Update Info</a></li>
                        </template>
                        <template v-if="userInfo.isAdmin">
                            <li><a :href="viewAccountLink()" @click.prevent="viewAccount">View Account</a></li>
                            <li><a :href="viewLocationLink()" @click.prevent="viewLocation">View Listing</a></li>
                        </template>
                        <template v-if="userInfo.isOwned">
                            <li v-if="!suppressRemove"><a href="#" @click.prevent="removeRequest">Remove Listing</a></li>
                            <li v-if="!suppressUpgrade"><a href="#" @click.prevent="upgradeRequest">Upgrade Listing</a></li>
                        </template>
                        <template v-if="!isDetails && (isPremiumListing || hasAdditionalData)">
                            <li><a href="#" @click.prevent="viewServices">View Services</a></li>
                        </template>
                        <template v-if="isPremiumListing && listing.properties.website != null">
                            <li><a href="#" @click.prevent="viewWebsite" rel="nofollow">View Website</a></li>
                        </template>

                        <li class="spacer"></li>

                        <li><a href="#" @click.prevent="showOnMap">Show on Map</a></li>
                        <template v-if="userInfo.isAuthenticated">
                            <li><a href="#" @click.prevent="shareLocation">Forward Listing</a></li>
                            <li><a href="#" @click.prevent="rateService">Rate Service</a></li>
                            <li><a href="#" @click.prevent="viewNotes">{{ noteLabel }}</a></li>
                        </template>
                        <template v-if="userInfo.isAce">
                            <li><a href="#" @click.prevent="editPreferred">{{ preferredLabel }}</a></li>
                            <li><a href="#" @click.prevent="addDnu">Avoid this Vendor</a></li>
                        </template>

                        <template v-if="!userInfo.isAuthenticated">
                            <li class="spacer"></li>
                            <li><a href="getUrl('/accounts/create-or-signin')">Create a free account or login to unlock features</a></li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
        <div class="body">
            <div v-if="isPremiumListing" class="logo">
                <a :href="detailLink" :title="listingDescription" @click.prevent="viewDetails">
                    <v-lazy-image height="178" width="178" :src="listing.properties.logoUrl" :alt="listing.name"></v-lazy-image>
                </a>
            </div>

            <div class="address">
                <hours-status-display :listing="listing"></hours-status-display>
                {{ listing.location.line1 }}<br />
                {{ listing.location.line2 }}
            </div>
            <div class="links">
                <template v-if="userInfo.isAdmin">
                    <a class="action" :href="editLocationLink()" title="Edit Location" @click.prevent="editLocation">
                        <div class="icon"><fa-icon :icon="['fas', 'circle-info']" aria-hidden="true"></fa-icon></div>
                        <div class="title">Edit Listing</div>
                    </a>
                    <a class="action" :href="editHoursLink()" title="Edit Hours" @click.prevent="editHours">
                        <div class="icon"><fa-icon :icon="['fas', 'calendar-days']" aria-hidden="true"></fa-icon></div>
                        <div class="title">Edit Hours</div>
                    </a>
                </template>
                <template v-if="!userInfo.isAdmin && userInfo.isOwned">
                    <a class="action" :href="customerEditLocationLink()" title="Edit Location" @click.prevent="customerEditLocation">
                        <div class="icon"><fa-icon :icon="['fas', 'circle-info']" aria-hidden="true"></fa-icon></div>
                        <div class="title">Edit Listing</div>
                    </a>
                    <a class="action" :href="customerEditHoursLink()" title="Edit Hours" @click.prevent="customerEditHours">
                        <div class="icon"><fa-icon :icon="['fas', 'calendar-days']" aria-hidden="true"></fa-icon></div>
                        <div class="title">Edit Hours</div>
                    </a>
                </template>
                <template v-if="!userInfo.isAdmin && !userInfo.isOwned">
                    <a class="action" href="#" title="Request a change to the listing information" @click.prevent="reportLocation">
                        <div class="icon"><fa-icon :icon="['fas', 'circle-info']" aria-hidden="true"></fa-icon></div>
                        <div class="title">Update Info</div>
                    </a>
                </template>
                <template v-if="userInfo.isAdmin">
                    <a class="action" :href="viewAccountLink()" title="View Account" @click.prevent="viewAccount">
                        <div class="icon"><fa-icon :icon="['fas', 'eye']" aria-hidden="true"></fa-icon></div>
                        <div class="title">View Account</div>
                    </a>
                    <a class="action" :href="viewLocationLink()" title="View Listing" @click.prevent="viewLocation">
                        <div class="icon"><fa-icon :icon="['fas', 'eye']" aria-hidden="true"></fa-icon></div>
                        <div class="title">View Listing</div>
                    </a>
                </template>
                <template v-if="userInfo.isOwned">
                    <a v-if="!suppressRemove" class="action" href="#" title="Request to remove listing" @click.prevent="removeRequest">
                        <div class="icon"><fa-icon :icon="['fas', 'xmark']" aria-hidden="true"></fa-icon></div>
                        <div class="title">Remove Listing</div>
                    </a>
                    <a v-if="!suppressUpgrade" class="action" href="#" title="Request a upgrade listing" @click.prevent="upgradeRequest">
                        <div class="icon"><fa-icon :icon="['fas', 'circle-up']" aria-hidden="true"></fa-icon></div>
                        <div class="title">Upgrade Listing</div>
                    </a>
                </template>

                <template v-if="!isdetails && (isPremiumListing || hasAdditionalData)">
                    <a class="action" href="#" title="View Services" @click.prevent="viewServices">
                        <div class="icon"><fa-icon :icon="['fas', 'screwdriver-wrench']" aria-hidden="true"></fa-icon></div>
                        <div class="title">View Services</div>
                    </a>
                </template>

                <template v-if="(isPremiumListing || userInfo.isFleet) && !isdetails">
                    <a class="action" :href="detailLink" title="Vendor Details" @click.prevent="viewDetails">
                        <div class="icon"><fa-icon :icon="['fas', 'eye']" aria-hidden="true"></fa-icon></div>
                        <div class="title">Vendor Details</div>
                    </a>
                </template>

                <template v-if="isPremiumListing && isdetails && listing.properties.website != null">
                    <a class="action" href="#" title="View Website" rel="nofollow" @click.prevent="viewWebsite">
                        <div class="icon"><fa-icon :icon="['fas', 'cloud']" aria-hidden="true"></fa-icon></div>
                        <div class="title">View Website</div>
                    </a>
                </template>
            </div>
            <div class="phonenumbers">
                <template v-if="showNumbers">
                    <div class="labels">
                        <div v-for="phn in phoneNumbers">
                            <span>{{ phn.label }}:</span>
                        </div>
                    </div>
                    <div class="numbers">
                        <div v-for="phn in phoneNumbers">
                            <span>{{ phn.display }}</span>
                        </div>
                    </div>
                    <div v-if="captchaWarning && captchaWarning.length > 0" class="warning">
                        <span>{{ captchaWarning }}</span>
                    </div>
                </template>
                <template v-else>
                    <div class="numbers">
                        <template v-if="isBlocked">
                            <span class="blocked">Our system has detected activity that represents a risk to our system, our users, or the businesses listed. As a result of this risk, your access has been restricted.</span>
                        </template>
                        <template v-if="displayCaptcha">
                            <span class="captcha">Please verify that you are not an automated bot.</span>
                            <div is="vue:captcha" :instance="captchaInstance"></div>
                        </template>
                        <template v-if="!isBlocked && !displayCaptcha">
                            <button @click="loadNumbers">
                                <div class="icon"><fa-icon :icon="['fas', 'phone']" aria-hidden="true"></fa-icon></div>
                                <div class="title">Show Numbers</div>
                            </button>
                        </template>
                    </div>
                    <div v-if="captchaWarning && captchaWarning.length > 0" class="warning">
                        <span class="warning">{{ captchaWarning }}</span>
                    </div>
                </template>
            </div>
            <div v-if="isPremiumListing" class="tagline">{{ listing.properties.tagLine }}</div>
            <div v-if="isPremiumListing" class="highlights clearfix">
                <div v-for="highlight in listing.properties.highlights">
                    <span class="icon"><fa-icon :icon="['far', 'circle-check']" aria-hidden="true"></fa-icon></span>
                    <span>{{ highlight }}</span>
                </div>
            </div>
        </div>
        <div :class="footerClass">
            <button class="action" href="#" title="Show on Map" @click.prevent="showOnMap">
                <div class="icon"><fa-icon :icon="['fas', 'map']" aria-hidden="true"></fa-icon></div>
                <div class="title">Show on Map</div>
            </button>
            <button :class="buttonClass('forwardForm', 'action')" href="#" title="Forward listing to somebody via email or sms text" @click.prevent="shareLocation">
                <div class="icon"><fa-icon :icon="['fas', 'share']" aria-hidden="true"></fa-icon></div>
                <div class="title">Forward</div>
            </button>
            <button :class="buttonClass('rateServiceForm', 'action')" href="#" title="Rate Service" @click.prevent="rateService">
                <div class="icon"><fa-icon :icon="['fas', 'star']" aria-hidden="true"></fa-icon></div>
                <div class="title">Rate Service</div>
            </button>
            <button :class="buttonClass('noteForm', 'action')" href="#" :title="noteLabel" @click.prevent="viewNotes">
                <div class="icon"><fa-icon :icon="['fas', 'sticky-note']" aria-hidden="true"></fa-icon><span class="badge" v-if="listing.notes.length > 0">{{ noteCount }}</span></div>
                <div class="title">{{ noteLabel }}</div>
            </button>
            <div class="action-double">
                <button @click.prevent="editPreferred" :class="buttonClass('favoriteForm', 'action favorite-btn', true)" :title="preferredLabel">
                    <div class="double-icon">
                        <fa-icon :icon="['fas', 'thumbs-up']" aria-hidden="true"></fa-icon>
                    </div>
                    <div>Favorite</div>

                </button>
                <button @click.prevent="addDnu" :class="buttonClass('avoidForm', 'action avoid-btn', true)" title="Remove from current and future search results">
                    <div class="double-icon">
                        <fa-icon :icon="['fas', 'thumbs-down']" aria-hidden="true"></fa-icon>
                    </div>
                    <div>Avoid</div>
                </button>
            </div>
        </div>
        <div class="data">
            <transition name="expand" appear>
                <listing-update-info v-if="openFormId == 'updateInfoForm'" :listing="listing"></listing-update-info>
            </transition>
            <transition name="expand" appear>
                <listing-forward v-if="openFormId == 'forwardForm'" :listing="listing"></listing-forward>
            </transition>
            <transition name="expand" appear>
                <listing-rate-service v-if="openFormId == 'rateServiceForm'" :initial-value="ratingInitialValue" :listing="listing"></listing-rate-service>
            </transition>
            <transition name="expand" appear>
                <listing-preference v-if="openFormId == 'favoriteForm'" preferred-type="favorite" :listing="listing"></listing-preference>
            </transition>
            <transition name="expand" appear>
                <listing-preference v-if="openFormId == 'avoidForm'" preferred-type="avoid" :listing="listing"></listing-preference>
            </transition>
            <transition name="expand" appear>
                <listing-notes v-if="openFormId == 'noteForm'" :listing="listing"></listing-notes>
            </transition>
            <transition name="expand" appear>
                <div v-if="openFormId == 'services'">
                    <div class="services services-action">
                        <h4 class="services-heading">Services & Amenities Offered</h4>
                        <ul class="service-list">
                            <li class="service" v-for="service in listingServices">
                                <fa-icon :icon="['fas', 'circle-check']" aria-hidden="true"></fa-icon>
                                <p>{{ service.name }}</p>
                                <ul v-if="getAmentities(service).length > 0">
                                    <li v-for="amenity in getAmentities(service)">
                                        <p>{{ amenity.name }}</p>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div class="additionalData" v-if="additionalData.length > 0">
                        <h4 class="services-heading">Additional Details</h4>
                        <ul class="service-list">
                            <li class="service" v-for="detail in additionalData">
                                <fa-icon :icon="['fas', 'circle-check']" aria-hidden="true"></fa-icon>
                                <p>{{ detail.key }}
                                <template v-if="detail.additionalFee">
                                    ($)
                                </template></p>
                                <div v-if="detail.value" class="fee">{{ detail.value }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </transition>
            <transition name="expand" appear>
                <div class="form-container" v-if="openFormId == 'removeRequest'">
                    <div class="form">
                        <div class="inputs-container">
                            <h2>Are you sure that you want to submit a request to have this listing removed?</h2>
                            <p>
                                This will submit a request to have your listing removed.  Your removal request will be processed within one business day (Monday to Friday). If you have any other questions or concerns or would like to speak to a TruckDown Representative in person, you can reach TruckDown toll-free at 1-877-300-7138.
                            </p>
                            <div class="warning">
                                <p>
                                    <strong>
                                        Changes will not be applied immediately. A TruckDown representative will contact you within 1-2 business days.  Your listing will continue to display on TruckDown until the removal process is finalized.
                                    </strong>
                                </p>
                            </div>
                            <div v-if="submitMessage.length > 0" class="warning">{{ submitMessage }}</div>
                        </div>

                        <div class="form-buttons">
                            <button class="cancel-btn" @click="closeListingForm(listing.id)">Cancel</button>
                            <button class="forward-btn" @click="submitRemoveRequest">Submit Request</button>
                        </div>
                    </div>
                </div>
            </transition>
            <transition name="expand" appear>
                <div class="form-container" v-if="openFormId == 'upgradeRequest'">
                    <div class="form">
                        <div class="inputs-container">
                            <h2>Are you sure that you want to submit a request to have this listing upgraded?</h2>
                            <p>
                                This will submit a request to have your listing upgraded.  Your upgrade request will be processed within one business day (Monday to Friday). If you have any other questions or concerns or would like to speak to a TruckDown Representative in person, you can reach TruckDown toll-free at 1-877-300-7138.
                            </p>
                            <div class="warning">
                                <p>
                                    <strong>
                                        No changes will be applied immediately. A TruckDown representative will contact you within 1-2 business days.
                                    </strong>
                                </p>
                            </div>
                        </div>

                        <div class="form-buttons">
                            <button class="cancel-btn" @click="closeListingForm(listing.id)">Cancel</button>
                            <button class="forward-btn" @click="submitUpgradeRequest">Submit Request</button>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="isdetails">
            <div v-show="showMap" class="mapContent">
                <GMapMap ref="gMap" :center="mapCenter" :zoom="11">
                    <GMapMarker :position="mapCenter" :clickable="true" @click="toggleMarker" :icon="mapGetIcon(listing)">
                        <GMapInfoWindow :opened="showMarker">
                            <h3>{{ listing.name }}</h3>

                            <div class="address">
                                <hours-status-display :listing="listing"></hours-status-display>
                                {{ listing.location.line1 }}<br />
                                {{ listing.location.line2 }}
                            </div>
                        </GMapInfoWindow>
                    </GMapMarker>
                </GMapMap>
            </div>
            <div class="details-container">
                <div class="column-left">
                    <div class="description" v-if="showDescription">
                        <h4>Description</h4>
                        <div v-html="listing.properties.description"></div>
                        <div class="additionalData" v-if="additionalData.length > 0">
                            <h4>Additional Details</h4>
                            <ul class="service-list">
                                
                                <li class="service" v-for="detail in additionalData">
                                    <fa-icon :icon="['fas', 'circle-check']" aria-hidden="true"></fa-icon>
                                    <p>{{ detail.key }}<template v-if="detail.additionalFee"> ($)</template></p>
                                    <div v-if="detail.value" class="fee">{{ detail.value }}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="services">
                        <h4>Services & Amenities Offered</h4>
                        <ul class="service-list">
                            <li class="service" v-for="service in listingServices">
                                <fa-icon :icon="['fas', 'circle-check']" aria-hidden="true"></fa-icon>
                                <p>{{ service.name }}</p>
                                <ul v-if="getAmentities(service).length > 0">
                                    <li v-for="amenity in getAmentities(service)">
                                        <p>{{ amenity.name }}</p>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>

                    <div class="dealers" v-if="showDealers">
                        <h4>Dealer Networks</h4>
                        <ul class="service-list">
                            <li class="service" v-for="network in listing.networks"><fa-icon :icon="['fas', 'circle-check']" aria-hidden="true"></fa-icon><p>{{ network.name }}</p></li>
                        </ul>
                    </div>
                   
                </div>
                <div class="column-right">
                    <div :class="['images', {'image-single': listing.properties.photoUrls.length == 1}]" v-if="showImages">
                        <div class="carousel-container" ref="carouselRef">
                            <a v-for="(image, index) in listing.properties.photoUrls" href="#" title="Listing image" >
                                <img :class="{active: index === activeIndex}" :src="image" alt="Listing image" @click.prevent="showImage(listing.properties.photoUrls[activeIndex])" />
                            </a>
                        </div>
                        <div class="arrow arrow-left" @click="prevImage(listing.properties.photoUrls.length)" v-if="listing.properties.photoUrls.length > 1">
                            <fa-icon :icon="['fas', 'caret-left']" aria-hidden="true"></fa-icon>
                        </div>
                        <div class="arrow arrow-right" @click="nextImage(listing.properties.photoUrls.length)" v-if="listing.properties.photoUrls.length > 1">
                            <fa-icon :icon="['fas', 'caret-right']" aria-hidden="true"></fa-icon>
                        </div>
                        <div class="carousel-indicators" v-if="listing.properties.photoUrls.length > 1">
                            <span v-for="(image, index) in listing.properties.photoUrls" :key="index" @click.prevent="goToSlide(index)" :class="{active: index === activeIndex}">
                            </span>
                        </div>
                        <div class="selected-image-container" v-if="selectedImage.length > 0">
                            <a href="#" @click.prevent="showImage('')">
                                <fa-icon class="close-icon" :icon="['fas', 'xmark']" aria-hidden="true"></fa-icon>
                            </a>
                            <img class="active" :src="selectedImage" alt="Selected listing image" />
                        </div>
                    </div>
                    <div class="hours-payment">
                        <listing-hours class="hours" :listing="listing"></listing-hours>
                        <div class="payment_types" v-if="showPaymentTypes">
                            <h4>Accepted Payment Types</h4>
                            <img v-for="payment in listing.properties.paymentTypes" :src="getPaymentImage(payment)" alt="" width="75" height="48" />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>import script from './Listing';
    export default script;</script>

<style lang="less" scoped>
    @import "./Listing.less";
</style>